/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/polo-history-tab` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de alterações de polo realizadas na matrícula com polo anterior, novo polo, tipo de ação, data e responsável, para exibição na aba Histórico de Polo do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna o histórico de polo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/polo-history-tab}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTabUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
